

export function registerDirectives(Vue){

    Vue.directive('focus',{
        inserted: function (el) {
            // Focus the element
            el.focus()
          }
    })
}


// WEBPACK FOOTER //
// ./resources/js/mixins/directives.js